import { useTranslation } from "../components/Translation"

import css from "../style.module.scss"

// Shown after returning from Stripe Checkout while the payment is not
// confirmed yet (delayed payment methods or a temporarily unreachable
// confirmation endpoint) — deliberately makes no promise of premium access.
export function PaymentPending({ onClose }: { onClose: () => void }) {
  const t = useTranslation()

  return (
    <div className={css.content}>
      <h3 className={css["success-title"]}>{t("payment_processing_title")}</h3>
      <p className={css["success-text"]}>{t("payment_processing_text")}</p>
      <button className={css.submit} type="button" onClick={onClose}>
        {t("close")}
      </button>
    </div>
  )
}
